import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as globalReducer from "containers/App/reducer";

class MainContainer extends React.PureComponent {
  render() {
    const { isLeftPanelOpen } = this.props;
    return (
      <div
        style={{
          width: isLeftPanelOpen ? "calc(100% - 250px)" : "100%",
          marginLeft: isLeftPanelOpen ? "250px" : "0px",
          transition: "all 0.2s"
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => ({
  isLeftPanelOpen: globalReducer.getIsLeftPanelOpen(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(MainContainer);
